import { useState } from "react";
import ArtCard from "../components/ArtCard";
import Lightbox from "../components/Lightbox";
import ShopFilters from "../components/ShopFilters";

export default function ShopPage({ shopItems }) {
  const [selected, setSelected] = useState(null);
  const [cat, setCat] = useState("All");

  const cats = [
    "All",
    ...Array.from(new Set(shopItems.map((i) => i.category).filter(Boolean))),
  ];
  const filtered =
    cat === "All" ? shopItems : shopItems.filter((i) => i.category === cat);

  return (
    <div className="page">
      <div className="section">
        <div className="section-header">
          <div className="section-ornament">
            <div className="section-ornament-line" />
            <span className="section-label">Acquire Originals</span>
            <div className="section-ornament-line" />
          </div>
          <h2 className="section-title">
            Shop <em>Artworks</em>
          </h2>
          <div className="section-rule" />
        </div>

        <ShopFilters cats={cats} active={cat} onChange={setCat} label="Filter:" />

        {filtered.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              color: "var(--ink-faint)",
              padding: "80px 0",
              fontStyle: "italic",
            }}
          >
            No artworks in this category yet.
          </div>
        ) : (
          <div className="cards-grid">
            {filtered.map((item) => (
              <ArtCard
                key={item.id}
                item={item}
                onClick={() => setSelected(item)}
                actions={[
                  <button
                    key="buy"
                    className="btn btn-ochre btn-sm"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Acquire
                  </button>,
                  <button
                    key="view"
                    className="btn btn-outline btn-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelected(item);
                    }}
                  >
                    Details
                  </button>,
                ]}
              />
            ))}
          </div>
        )}
      </div>

      {selected && (
        <Lightbox item={selected} onClose={() => setSelected(null)} />
      )}
    </div>
  );
}
